<template>
  <div class="page-content">
     <div class="container-fluid">
        <div class="row">
           <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                 <h4 class="mb-0 font-size-18">Server Settings</h4>
                 <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                       <li class="breadcrumb-item"><a href="javascript: void(0);">Your Server</a></li>
                       <li class="breadcrumb-item active">Settings</li>
                    </ol>
                 </div>
              </div>
           </div>
        </div>
        <!-- end page title -->
        <div class="row">
           <div class="col-lg-6">
              <div class="card">
                 <div class="card-body">
                    <h4 class="card-title">Server IP Address</h4>
                    <p class="card-title-desc">Change your server IP address.</p>
                    <div>
                       <div class="input-group mb-4">
                          <input class="form-control" type="text" placeholder="Enter server name" value="duckyserver">
                          <div class="input-group-prepend">
                             <span class="input-group-text" id="option-date">.spc.mn</span>
                             <button type="button" class="btn btn-primary waves-effect">Update</button>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-lg-6">
              <div class="card">
                 <div class="card-body">
                    <h4 class="card-title">Server MOTD</h4>
                    <p class="card-title-desc">Change your server MOTD</p>
                    <div>
                       <div class="input-group mb-4">
                          <input class="form-control" type="text" placeholder="Enter server MOTD" value="&6&lDucky Server!">
                          <div class="input-group-prepend">
                             <span class="input-group-text" id="option-date">- Powered by SpaceMine</span>
                             <button type="button" class="btn btn-primary waves-effect">Update</button>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>
           </div>
        </div>
        <!-- end row -->
        <div class="row">
           <div class="col-lg-12">
              <div class="card">
                 <div class="card-body">
                    <h4 class="card-title">Server.Properties</h4>
                    <p class="card-title-desc"></p>
                    <div class="row">
                       <div class="col-lg-6">
                          <div class="card">
                             <div class="card-body">
                                <h4 class="card-title">Player Slots</h4>
                                <div>
                                   <div class="input-group mb-4">
                                      <input class="form-control" type="text" placeholder="Enter server name" value="10">
                                      <div class="input-group-prepend">
                                         <button type="button" class="btn btn-primary waves-effect">Update</button>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                       <div class="col-lg-6">
                          <div class="card">
                             <div class="card-body">
                                <h4 class="card-title">Gamemode</h4>
                                <div>
                                   <div class="input-group mb-4">
                                      <select class="form-control">
                                         <option>Survival</option>
                                         <option>Creative</option>
                                         <option>Adventure</option>
                                      </select>
                                      <div class="input-group-prepend">
                                         <button type="button" class="btn btn-primary waves-effect">Update</button>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                       <div class="col-lg-6">
                          <div class="card">
                             <div class="card-body">
                                <h4 class="card-title">Online Mode</h4>
                                <div>
                                   <div class="input-group mb-4">
                                      <select class="form-control">
                                         <option>True</option>
                                         <option>False</option>
                                      </select>
                                      <div class="input-group-prepend">
                                         <button type="button" class="btn btn-primary waves-effect">Update</button>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                       <div class="col-lg-6">
                          <div class="card">
                             <div class="card-body">
                                <h4 class="card-title">Difficulty</h4>
                                <div>
                                   <div class="input-group mb-4">
                                      <select class="form-control">
                                         <option>Easy</option>
                                         <option>Peaceful</option>
                                         <option>Normal</option>
                                         <option>Hardcore</option>
                                      </select>
                                      <div class="input-group-prepend">
                                         <button type="button" class="btn btn-primary waves-effect">Update</button>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  data () {
    return { }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/panel/Settings.vue